/**
 * @packageDocumentation
 * @module f1/fn
 */

export interface Identity {
  /**
   * Returns the value you pass to the function
   *
   * @public
   * @function f1.identity
   * @param value the value to pass
   * @example
   *
   * ```ts
   * identity(true) === true
   * identity(1) === 1
   * identity({ foo: 1 }) === { foo: 1 }
   * ```
   */
  <V>(value: V): V;
}

/**
 * @see Identity
 */
export default <V>(value: V): V => value;
